module.exports = __webpack_public_path__ + "static/img/BH@2x.d19553e5.jpg";